/*  ========================================================================
    # Scripts - Page Status
    ========================================================================  */

/**
 * Script that checks the current status of the page
 * and adds the corresponding classes to the html tag.
 */

const PageStatus = {
  cfg: {
    html: document.querySelector('html'),
    states: {
      loading: 'page-loading',
      complete: 'page-complete',
      scrolled: 'page-scrolled'
    }
  },

  /**
   * Add "page-loading".
   */
  pageLoading() {
    this.cfg.html.classList.add(this.cfg.states.loading);
  },

  /**
   * Remove "page-loading" and add "page-complete" when the page is loaded.
   */
  pageComplete() {
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        setTimeout(() => {
          this.cfg.html.classList.remove(this.cfg.states.loading);
          this.cfg.html.classList.add(this.cfg.states.complete);
        }, 1000);
      }
    };
  },

  /**
   * Add "page-scrolled" when the page is scrolled past 200px.
   */
  pageScrolled() {
    window.onscroll = () => {
      setTimeout(() => {
        if (window.pageYOffset >= 50) {
          this.cfg.html.classList.add(this.cfg.states.scrolled);
        } else {
          this.cfg.html.classList.remove(this.cfg.states.scrolled);
        }
      }, 100);
    };
  },

  /**
   * Detect the user's mobile operating system and store it in the class list
   */
  detectOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      this.cfg.html.classList.add('os-android');
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.cfg.html.classList.add('os-ios');
    } else {
      this.cfg.html.classList.add('os-other');
    }
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.html.classList.contains('js')) {
      this.pageLoading();
      this.detectOS();
      this.pageComplete();
      this.pageScrolled();
    }
  }
};


export default PageStatus;
